import * as CookieConsent from 'vanilla-cookieconsent';

const initCookies = () => {
    /**
     * All config. options available here:
     * https://cookieconsent.orestbida.com/reference/configuration-reference.html
     */

    // Enable autoShow by default
    let autoShow = true;

    // If splash not played and home page, disable autoShow
    const splashPlayed = sessionStorage.getItem('splashShown');

    if (document.body.dataset.page === 'home' && !splashPlayed) {
        autoShow = false;
    }

    CookieConsent.run({
        autoShow,
        categories: {
            necessary: {
                enabled: true, // this category is enabled by default
                readOnly: true // this category cannot be disabled
            },
            analytics: {
                enabled: false
            }
        },
        language: {
            default: 'en',
            translations: {
                en: {
                    consentModal: {
                        title: 'We use cookies',
                        description: 'Our site uses cookies which helps us to improve our site and enables us to deliver the best possible service.',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        showPreferencesBtn: 'Manage preferences',
                    },
                    preferencesModal: {
                        title: 'Manage cookie preferences',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        savePreferencesBtn: 'Accept current selection',
                        closeIconLabel: 'Close modal',
                        sections: [
                            {
                                title: 'We use cookies',
                                description: 'Our site uses cookies, which helps us to improve our site and enables us to deliver the best possible service and experience.'
                            },
                            {
                                title: 'Strictly Necessary cookies',
                                description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                                linkedCategory: 'necessary'
                            },
                            {
                                title: 'Performance and Analytics',
                                description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                                linkedCategory: 'analytics',
                            },
                            {
                                title: 'More information',
                                description: 'For any queries in relation to my policy on cookies and your choices, please <a href="/contact">contact us</a>'
                            }
                        ]
                    }
                }
            }
        }
    });

    document.documentElement.classList.add('cc--darkmode');
};

export default initCookies;
